var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPureRotation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03125 8.5C5.64983 5.29564 8.82483 5.00001 11.9999 5C15.175 4.99999 18.3501 5.29562 17.9688 8.5C17.3989 13.2876 16.8 19 12.6737 19H11.3263C7.2 19 6.60113 13.2876 6.03125 8.5Z",
    fill: "#C9D2D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 1.91667V1H12.5V1.91667H11.5ZM11.5 5.58333V3.75H12.5V5.58333H11.5ZM11.5 9.25V7.41667H12.5V9.25H11.5ZM11.5 12.9167V11.0833H12.5V12.9167H11.5ZM11.5 16.5833V14.75H12.5V16.5833H11.5ZM11.5 20.25V18.4167H12.5V20.25H11.5ZM11.5 23V22.0833H12.5V23H11.5Z",
    fill: "#647B8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0235 10L18.2 11.0245L19.7755 11.9452C17.9553 13.7035 15.0375 14.6637 11.9986 14.6697C9.03482 14.6755 6.19021 13.7735 4.36455 12.084L5.85879 11.2108L2.03523 10.1863L1 14.05L2.57736 13.1283C4.8726 15.556 8.50496 16.6765 12.0025 16.6697C15.5689 16.6627 19.2705 15.4832 21.5539 12.9843L23.0587 13.8636L22.0235 10Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPureRotation);
export default __webpack_public_path__ + "static/media/pure-rotation.d53642b6.svg";
export { ForwardRef as ReactComponent };